module.exports = __webpack_public_path__ + "assets/img/micronet-member.e947862c.png";